export default __webpack_public_path__ + "static/media/DreamStreamLogoBackground.4b34f62b.svg";